import Vue from 'vue'
import Router from 'vue-router'
import TarmCalls from './views/tarm/TarmCalls.vue'
import Login from './views/Login.vue'
import Authentication from './components/shared/login/Authentication'
import ForgotPassword from './components/shared/login/ForgotPassword'
import RecoveryPassword from './components/shared/login/RecoveryPassword'
import SuccessRecovery from './components/shared/login/SuccessRecovery'
import ErrorRecovery from './components/shared/login/ErrorRecovery'
import DoctorCalls from './views/medico-regulador/DoctorCalls.vue'
import UserProfile from './views/share/UserProfile.vue'
import TermsOfUse from "./views/share/TermsOfUse";
import UsersList from "./views/admin/users/UsersList";
import NewUser from './views/admin/users/NewUser'
import ChangeUser from './views/admin/users/ChangeUser'
import Ambulances from './views/admin/ambulance/AmbulancesTable'
import NewAmbulance from './views/admin/ambulance/NewAmbulance'
import EditAmbulance from './views/admin/ambulance/EditAmbulance'
import UsersRules from './views/admin/rules/UsersRules'
import NewRule from './views/admin/rules/NewRule'
import EditRule from './views/admin/rules/EditRule'
import Hospitals from './views/admin/hospital/Hospitals'
import NewHospital from './views/admin/hospital/NewHospital'
import EditHospital from './views/admin/hospital/EditHospital'
import UnauthorizedAccess from './views/share/UnauthorizedAccess'
import Bases from "./views/admin/bases/Bases";
import AbsenceReport from "./views/admin/nursing_staff/AbsenceReport";
import ViewNurse from "./views/admin/nursing_staff/ViewNurse"
import NursingStaff from "./views/admin/nursing_staff/NursingStaff";
import GeneralFleet from "./views/admin/general_fleet/GeneralFleet";
import HazingPhoneNumbers from "./views/admin/hazing_calls/HazingPhoneNumbers";
import FleetManager from "./views/fleet-manager/FleetManager";
import About from "./views/About";

Vue.use(Router)

export default new Router({
  mode:'history',
  base:process.env.BASE_URL,
  routes:[
    {
      path:'/erroraccess',
      name:'UnauthorizedAccess',
      component:UnauthorizedAccess,
      meta:{
        guest:true
      }
    },
    {
      path:'/',
      name:'Login',
      component:Login,
      meta:{
        guest:true
      },
      children:[
        {
          path:'',
          name:'authentication',
          component:Authentication,
          meta:{
            guest:true
          },
        },
        {
          path:'esqueceusenha',
          name:'ForgotPassword',
          component:ForgotPassword,
          meta:{
            guest:true
          },
        },
        {
          path:'recuperarsenha',
          name:'RecoveryPassword',
          component:RecoveryPassword,
          meta:{
            guest:true
          },
        },
        {
          path:'success',
          name:'SuccessRecovery',
          component:SuccessRecovery,
          meta:{
            guest:true
          },
        },
        {
          path:'error',
          name:'ErrorRecovery',
          component:ErrorRecovery,
          meta:{
            guest:true
          },
        },
        {
          path:'about',
          name:'about',
          component:About,
          meta:{
            guest:true
          },
        }
      ]

    },
    {
      path:'/userslist',
      name:'UsersList',
      component:UsersList,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/Bases',
      name:'Bases',
      component:Bases,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/tarmcalls',
      name:'TarmCalls',
      component:TarmCalls,
      meta:{
        requiresAuth:true,
        rules:['admin','tarm']
      }
    },
    {
      path:'/FleetManager',
      name:'FleetManager',
      component:FleetManager,
      meta:{
        requiresAuth:true,
        rules:['admin','fleet-manager']
      }
    },
    {
      path:'/doctorcalls',
      name:'DoctorCalls',
      component:DoctorCalls,
      meta:{
        requiresAuth:true,
        rules:['admin','regulatory-physician']
      }
    },
    {
      path:'/termsofuse',
      name:'TermsOfUse',
      component:TermsOfUse,
      meta:{
        requiresAuth:true,
        rules:['admin','regulatory-physician','fleet-manager','tarm']
      }
    },
    {
      path:'/profile',
      name:'UserProfile',
      component:UserProfile,
      meta:{
        requiresAuth:true,
        rules:['admin','regulatory-physician','fleet-manager','tarm']
      }
    },
    {
      path:'/newuser',
      name:'NewUser',
      component:NewUser,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/changeuser/:id',
      name:'ChangeUser',
      component:ChangeUser,
      props:true,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/ambulances',
      name:'Ambulances',
      component:Ambulances,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/newambulance',
      name:'NewAmbulance',
      component:NewAmbulance,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/editambulance/:id',
      name:'EditAmbulance',
      component:EditAmbulance,
      props:true,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/usersrules',
      name:'UsersRules',
      component:UsersRules,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/newrule',
      name:'NewRule',
      component:NewRule,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/editrule',
      name:'EditRule',
      component:EditRule,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/hospital',
      name:'Hospitals',
      component:Hospitals,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/generalfleet',
      name:'GeneralFleet',
      component:GeneralFleet,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/newhospital',
      name:'NewHospital',
      component:NewHospital,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/edithospital/:id',
      name:'EditHospital',
      component:EditHospital,
      props:true,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:"/absencereport",
      name:"AbsenceReport",
      component:AbsenceReport,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:'/viewnurse/:id',
      name:'ViewNurse',
      component:ViewNurse,
      props:true,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:"/nursingstaff",
      name:"NursingStaff",
      component:NursingStaff,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
    {
      path:"/hazingcalls",
      name:"HazingPhoneNumbers",
      component:HazingPhoneNumbers,
      meta:{
        requiresAuth:true,
        rules:['admin']
      }
    },
  ]
})
